import { render, staticRenderFns } from "./PageFamilyUserMissionAdd.vue?vue&type=template&id=5061f55c&scoped=true&"
import script from "./PageFamilyUserMissionAdd.vue?vue&type=script&lang=js&"
export * from "./PageFamilyUserMissionAdd.vue?vue&type=script&lang=js&"
import style0 from "./PageFamilyUserMissionAdd.vue?vue&type=style&index=0&id=5061f55c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5061f55c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VForm})
